module.exports = __webpack_public_path__ + "img/play1.f8047149.svg";